import classNames from 'classnames';
import React from 'react';
import { MaybeUndef } from '../../../../types/system';
import bytes from '../../../../utils/bytes/bytes';
import { OperationStatus } from '../../operation-groups/operation-groups.types';
import { OperationStatusPresentation } from '../operation-status-presentation/operation-status-presentation';
import styles from './operation-row.scss';
import { Text } from '@wix/design-system';

interface Props {
  thumb: React.ReactNode;
  name: React.ReactNode;
  size?: number;
  status: OperationStatus;
  progress?: MaybeUndef<number>;
  cancelButtonHint?: string;
  onLocateClick?(): void;

  onRetryClick?(): void;

  onCancelClick?(): void;
}

export const OperationRow: React.FunctionComponent<Props> = ({
  thumb,
  progress,
  name,
  size,
  status,
  onLocateClick,
  onRetryClick,
  onCancelClick,
  cancelButtonHint,
}: Props) => {
  const pendingClass = {
    [styles.pending]:
      status === OperationStatus.Pending ||
      (status === OperationStatus.InProgress && progress === 0),
  };

  return (
    <div className={styles.operationRow}>
      <div className={classNames(styles.thumb, pendingClass)}>{thumb}</div>

      <div className={classNames(styles.name, pendingClass)}>
        <Text ellipsis={true} size="small">
          {name}
        </Text>
      </div>

      <div className={classNames(styles.size, pendingClass)}>
        <Text size="small" secondary>
          {size === undefined ? 'N/A' : bytes.format(size)}
        </Text>
      </div>

      <div className={styles.status}>
        <OperationStatusPresentation
          status={status}
          progress={progress}
          onLocateClick={onLocateClick}
          onRetryClick={onRetryClick}
          onCancelClick={onCancelClick}
          cancelButtonHint={cancelButtonHint}
        />
      </div>
    </div>
  );
};
